      async function LoadMoreFunction() {
      const products_on_page = document.querySelector(".product-grid");
      const loadMoreBtn = document.querySelector("#load-more-button");
      let nextUrl = products_on_page.getAttribute("data-next-url");
      if (!nextUrl) {
        loadMoreBtn.style.display = "none";
        return;
      }

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = "Loading...";

      try {
        console.log("Fetching URL:", nextUrl);
        const response = await fetch(nextUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const htmlText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, "text/html");
        const newProducts = doc.querySelector(".product-grid");

        products_on_page.innerHTML += newProducts.innerHTML;

        const newNextUrl = doc.querySelector(".product-grid")?.getAttribute("data-next-url");

        if (newNextUrl) {
          products_on_page.setAttribute("data-next-url", newNextUrl);
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = "Load More";
        } else {
          products_on_page.removeAttribute("data-next-url");
          loadMoreBtn.style.display = "none";
        }
        console.log("Products loaded successfully!");
      } catch (error) {
        console.error("Fetch error:", error);
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = "Load More";
      }
    }
    document.querySelector("#load-more-button").addEventListener("click", LoadMoreFunction);
      // window.addEventListener("scroll", () => {
      //     if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200) {
      //         LoadMoreFunction();
      //     }
      //   });

  function setupCustomFilterOpen() {
    document.querySelectorAll('.cutsom-filter-main').forEach(function(filter) {
      filter.addEventListener('click', function() {
        const filter_open = document.querySelector('.facets-wrapper');
        const product_grid = document.querySelector('.product-grid-container');
        if (filter_open){
          filter_open.classList.add('expanded');
        }
        if (product_grid){
          product_grid.classList.add('custom-full-width');
        }
      });
    });
  }
  setupCustomFilterOpen();

  function setupCustomFilterClose(){
        document.querySelectorAll('.custom-close').forEach(function(filter) {
        filter.addEventListener('click', function() {
          const filter_close = document.querySelector('.facets-wrapper');
          const product_grid = document.querySelector('.product-grid-container');
          if (filter_close){
            filter_close.classList.remove('expanded');          
          }
          if (product_grid){
            product_grid.classList.remove('custom-full-width');
          }
        });
      });
  }
  setupCustomFilterClose();